/**
 * useScrollToTop - Scrolls the window to the top on every route change.
 * Place this once near the top of the component tree (inside BrowserRouter)
 * so all page navigations reset the scroll position.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
};
